import type { Plan } from '@/app_lib/types/Plan';

const idApiBase = process.env.PIANO_ID_API_BASE_URL || '';
const aid = process.env.PIANO_AID || '';
const apiBase = process.env.PIANO_API_BASE_URL || '';
const apiToken = process.env.PIANO_API_TOKEN || '';
const auth = `aid=${aid}&api_token=${apiToken}`;

export const pianoIdEndpoints = {
  getSocialUrl: '/publisher/login/social',
  getUser: '/publisher/users/get',
  login: '/publisher/login',
  register: '/publisher/register',
  resetPassword: '/publisher/reset/password',
  socialLogin: '/publisher/login/social/code',
};

export const pianoApi = (endpoint) => `${apiBase}${endpoint}?${auth}`;
export const pianoIdApi = (endpoint: string, additionalParams = '') =>
  `${idApiBase}${endpoint}?${auth}${additionalParams}`;
export const pianoEndpoints = {
  linkedTerm: '/publisher/linkedTerm/event',
  listTerms: '/publisher/term/list',
};

export function standardizePeriod(length: number, unit: string) {
  // Piano only accepts 1 week, 4 weeks, 1 month, 1 quarter, bi-annual, annual
  if (unit === 'days') {
    if (length === 7) {
      return '1 week';
    }
    if (length === 28) {
      return '4 weeks';
    }
  }
  if (unit === 'months') {
    if (length === 1) {
      return '1 month';
    }
    if (length === 3) {
      return '1 quarter';
    }
    if (length === 6) {
      return 'bi-annual';
    }
    if (length === 12) {
      return 'annual';
    }
  }
  return '';
}

export function derivePeriodFromPlan(plan: Plan): string {
  const { trial_length, trial_unit, interval_length, interval_unit } = plan;

  if (trial_length && trial_unit) {
    return standardizePeriod(trial_length, trial_unit);
  }
  return standardizePeriod(interval_length, interval_unit);
}
